import { CHART_COLORS } from "../styles/theme";

const CONTRACT_LABELS = {
    CDI: "CDI",
    CDD: "CDD",
    Other: "Autre",
};

const CONTRACT_COLORS = {
    CDI: CHART_COLORS.violet,
    CDD: CHART_COLORS.blue,
    Other: CHART_COLORS.violetSoft,
};

/* Le back ne renvoie pas de couleur : les autres types de contrat piochent ici */
const CONTRACT_FALLBACK_PALETTE = [
    CHART_COLORS.violetMid,
    CHART_COLORS.blueSoft,
    CHART_COLORS.amber,
    CHART_COLORS.violetDark,
    CHART_COLORS.grey,
];

const buildContractColor = () => {
    let next = 0;
    return (label) =>
        CONTRACT_COLORS[label] ??
        CONTRACT_FALLBACK_PALETTE[next++ % CONTRACT_FALLBACK_PALETTE.length];
};

/** Variation en % entre deux valeurs ; null si pas de référence exploitable */
export const pctChange = (current, previous) => {
    if (previous === null || previous === undefined || previous === 0) {
        return null;
    }
    return ((current - previous) / previous) * 100;
};

/**
 * Transforme la réponse de GET /hr/pilotage/effectif en modèle
 * consommé par EffectifSection.
 */
export const mapEffectif = (api) => {
    const headcount = api.headcount ?? 0;
    const byContract = api.by_contract ?? [];
    const findContract = (label) =>
        byContract.find((c) => c.label === label)?.count ?? 0;

    const contractColor = buildContractColor();

    const cadresPct = api.executives_pct ?? 0;
    const tempsPleinPct = api.full_time_pct ?? 0;

    return {
        headcount,
        headcountPrevious: api.headcount_previous ?? null,
        etp: api.fte ?? 0,
        etpPrevious: api.fte_previous ?? null,
        effectifMoyen: api.average_headcount ?? 0,
        effectifMoyenPrevious: api.average_headcount_previous ?? null,
        evolution: api.change_pct ?? 0,
        evolutionPrevious: api.change_pct_previous ?? null,
        contrats: {
            cdi: findContract("CDI"),
            cdd: findContract("CDD"),
            autre: findContract("Other"),
        },
        contratRows: byContract.map((c) => ({
            name: CONTRACT_LABELS[c.label] ?? c.label,
            value: c.count ?? 0,
            pct: c.pct ?? 0,
            color: contractColor(c.label),
        })),
        deptRows: (api.by_department ?? []).map((d) => ({
            id: d.department_id,
            name: d.department_name,
            value: d.count ?? 0,
        })),
        cadresPct,
        cadresPctPrevious: api.executives_pct_previous ?? null,
        cadresCount: Math.round((headcount * cadresPct) / 100),
        tempsPleinPct,
        tempsPleinPctPrevious: api.full_time_pct_previous ?? null,
        tempsPleinCount: Math.round((headcount * tempsPleinPct) / 100),
    };
};
